module.exports = __webpack_public_path__ + "img/m-abt.7191f29c.webp";